// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-compare-lite{padding:20px;border-radius:var(--aaa44v);border:2px solid var(--1loja20)}@media only screen and (min-width:992px){.home-compare-lite{padding:40px 20px;border-radius:var(--13d0htc)}}@media only screen and (min-width:1239px){.home-compare-lite{padding:40px}}.home-compare-lite__title.page-title{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
